import React, {Component} from "react";
import Filter from "../../filter/filter.component";
export class ReportBody extends Component {
    render(){
        return(
            <>
                 <h1 className="report-detail-title">{this.props.title}</h1>
                 <Filter data={[]}/>   
                 <div className="main-body-wrapper">
                        {this.props.children}
                 </div> 
            </>
        );
    }
}